import { Typography } from '@mui/material';
import type { ConnectorUptimeSummary } from 'types/swagger';
import { secondsToHoursMinutesSeconds } from 'util/uptime';

import type { PeriodType, TimeSpentByPeriod } from './interfaces';

type HeartbeatDonutLabelsProps = {
  timeSpent: TimeSpentByPeriod;
  periodType: PeriodType;
  isLoading: boolean;
};

type HeartbeatType = {
  type: keyof ConnectorUptimeSummary;
  label: string;
  color: string;
};

const HeartbeatDonutLabels: React.FC<HeartbeatDonutLabelsProps> = ({
  timeSpent,
  periodType,
  isLoading,
}) => {
  const heartbeatType: HeartbeatType[] = [
    {
      type: 'Idle',
      label: 'Disponible',
      color: '#FFFFFF',
    },
    {
      type: 'Charging',
      label: 'Ocupado',
      color: '#00FF7F',
    },
    {
      type: 'Faulted',
      label: 'Con falla',
      color: '#C51462',
    },
    {
      type: 'Offline',
      label: 'Fuera de línea',
      color: '#808080',
    },
  ];

  const getDisplayTime = (type: keyof ConnectorUptimeSummary) => {
    const timeData = timeSpent && timeSpent[type];

    const totalSeconds = (timeData?.minutes || 0) * 60;
    const { hours, minutes } = secondsToHoursMinutesSeconds(totalSeconds);

    if (isLoading || !timeData) {
      return periodType === 'lastDay' ? `- - mins` : `- - hrs - - mins`;
    }

    const hourText = hours === 1 ? 'hr' : 'hrs';
    const minuteText = minutes === 1 ? 'min' : 'mins';

    if (periodType === 'lastDay') {
      return `${timeData?.minutes || 0} ${minuteText}`;
    }

    return `${hours} ${hourText} ${minutes} ${minuteText}`;
  };

  return (
    <ul>
      {heartbeatType.map((heartbeat) => {
        return (
          <li key={heartbeat.label} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div
              style={{
                height: 10,
                width: 10,
                borderRadius: '50%',
                backgroundColor: heartbeat.color,
              }}
            ></div>
            <Typography
              fontSize={16}
              fontWeight={400}
              style={{ fontVariantNumeric: 'tabular-nums' }}
            >
              {getDisplayTime(heartbeat.type)} - {heartbeat.label}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
};

export default HeartbeatDonutLabels;
